import axios from "axios";

// export const BaseUrl = "http://localhost:5087/api/";
// export const BaseUrl = "https://t2back.gunvortech.com/api/";
// export const BaseUrl = "https://qaelectricb.gunvortech.com/api/";
export const BaseUrl = "https://lhomesb.gunvortech.com/api/";
// export const BaseUrl = "https://lphoneb.gunvortech.com/api/";
// export const BaseUrl = "https://hfashionb.gunvortech.com/api/";
// export const BaseUrl = "https://hgiftb.gunvortech.com/api/";
// export const BaseUrl = "https://hafezb.gunvortech.com/api/";
// export const BaseUrl = "https://colorsb.gunvortech.com/api/";

// Axios response interceptor — detect network failures & 500 errors
axios.interceptors.response.use(
  (response) => {
    if (response.status >= 500) {
      window.dispatchEvent(
        new CustomEvent("server-error", { detail: { type: "server" } }),
      );
    }
    return response;
  },
  (error) => {
    if (!error.response) {
      // Network error — server unreachable or no internet
      window.dispatchEvent(
        new CustomEvent("server-error", { detail: { type: "network" } }),
      );
    } else if (error.response.status >= 500) {
      window.dispatchEvent(
        new CustomEvent("server-error", { detail: { type: "server" } }),
      );
    }
    return Promise.reject(error);
  },
);

export const controller = {
  User: "User",
  UserRole: "UserRole",
  Auth: "Auth",
  Org: "Org",
  Outlet: "Outlet",
  Tax: "Tax",
  City: "City",
  PayType: "PayType",
  CstmrGroup: "CstmrGroup",
  Customer: "Customer",
  CustomerVehicle: "CustomerVehicle",
  VehicleBrand: "VehicleBrand",
  Service: "Service",
  ServiceCategory: "ServiceCategory",
  ServiceBay: "ServiceBay",
  ServiceDiscountType: "ServiceDiscountType",
  Employee: "Employee",
  Category: "Category",
  Supplier: "Supplier",
  Brand: "Brand",
  Tag: "Tag",
  Product: "Product",
  ProdAttr: "ProdAttr",
  Stock: "Stock",
  Inventory: "Inventory",
  Register: "Register",
  SellReg: "SellReg",
  Sell: "Sell",
  CashSalesInvoice: "CashSalesInvoice",
  CashMgmt: "CashMgmt",
  ParkSale: "ParkSale",
  UserCheckInOut: "UserCheckInOut",
  QuoteSale: "QuoteSale",
  CustomerTxn: "CustomerTxn",
  SellReturn: "SellReturn",
  HomeReport: "HomeReport",
  SupplierTxn: "SupplierTxn",
  StockReturn: "StockReturn",
  Report: "Report",
  StockReport: "StockReport",
  LogReport: "LogReport",
  PrintLabel: "PrintLabel",
  FollowUpType: "FollowUpType",
  InqSrc: "InqSrc",
  Inquiry: "Inquiry",
  FollowUp: "FollowUp",
  Currency: "Currency",
  Expense: "Expense",
  ExpenseType: "ExpenseType",
  FiscalYear: "FiscalYear",
  InventoryCount: "InventoryCount",
  SalesReport: "SalesReport",
  PaymentReport: "PaymentReport",
  SalesSummary: "SalesSummary",
  BusinessActivity: "BusinessActivity",
  Enum: "Enum",
  Company: "Company",
  TimeZone: "TimeZone",
  Ledger: "Ledger",
  Coa: "Coa",
  AccountMapping: "AccountMapping",
  JournalEntry: "JournalEntry",
  JournalVoucher: "JournalVoucher",
  StockTransfer: "StockTransfer",
  InventoryAdjustment: "InventoryAdjustment",
  PriceCategory: "PriceCategory",
  AccountTransfer: "AccountTransfer",
  BankAccount: "BankAccount",
  BankReconciliation: "BankReconciliation",
  UnitCategory: "UnitCategory",
  Unit: "Unit",
  Commission: "Commission",
  Coupon: "Coupon",
  PromotionApproval: "PromotionApproval",
};

export const action = {
  SupplierDue: "/SupplierDue",
  AccountStatement: "/AccountStatement",
  ExportStatement: "/ExportStatement",
  ExportStatementPdf: "/ExportStatementPdf",
  BizContextDetails: "/BizContextDetails",
  GetSpecificProd: "/GetSpecificProd",
  ExportStockMovement: "/ExportStockMovement",
  ExportStockMovementPdf: "/ExportStockMovementPdf",
  ExportOrderPdf: "/ExportOrderPdf",
  ExportReceivePdf: "/ExportReceivePdf",
  CreateReceipt: "/CreateReceipt",
  VoidReceipt: "/VoidReceipt",
  CloseShort: "/CloseShort",
  GetReceiptsByPo: "/GetReceiptsByPo",
  ExportGrnPdf: "/ExportGrnPdf",
  StockMovement: "/StockMovement",
  Export: "/Export",
  CountByStatus: "/CountByStatus",
  ExportVouchers: "/ExportVouchers",
  ExportVouchersPdf: "/ExportVouchersPdf",
  ExportVoucher: "/ExportVoucher",
  ExportVoucherPdf: "/ExportVoucherPdf",
  GetLastJvId: "/GetLastJvId",
  ExportSalesHistory: "/ExportSalesHistory",
  GetAllByInq: "/GetAllByInq",
  GetLabelsByCo: "/GetLabelsByCo",
  ExportJournalEntries: "/ExportJournalEntries",
  GetHierarchyByLedger: "/GetHierarchyByLedger",
  CustomerSubledgerPanel: "/CustomerSubledgerPanel",
  SupplierSubledgerPanel: "/SupplierSubledgerPanel",
  SubledgerReconciliation: "/SubledgerReconciliation",
  GetUnmappedAccLabelByLedger: "/GetUnmappedAccLabelByLedger",
  ExportMapping: "/ExportMapping",
  IsTxnExist: "/IsTxnExist",
  IsCodeExist: "/IsCodeExist",
  GetParentLabelsByLedger: "/GetParentLabelsByLedger",
  GetParentLabelsByCompany: "/GetParentLabelsByCompany",
  GetAllByCompany: "/GetAllByCompany",
  GetLabelsByCompany: "/GetLabelsByCompany",
  GetPostableLabels: "/GetPostableLabels",
  GetCashBankLabels: "/GetCashBankLabels",
  GetCashBankSummary: "/GetCashBankSummary",
  GetAccountTransactions: "/GetAccountTransactions",
  ExportAccountTransactions: "/ExportAccountTransactions",
  SuggestNextCode: "/SuggestNextCode",
  GetAllByLedger: "/GetAllByLedger",
  ExportChartOfAccounts: "/ExportChartOfAccounts",
  GenerateDefaultCoaByLedger: "/GenerateDefaultCoaByLedger",
  ExportLedgers: "/ExportLedgers",
  CompanyLedgers: "/CompanyLedgers",
  ExportCompanies: "/ExportCompanies",
  GetEnum: "/GetEnum",
  GetDetailsWithWorkTimes: "/GetDetailsWithWorkTimes",
  TaxReport: "/TaxReport",
  ExportSells: "/ExportSells",
  GetSells: "/GetSells",
  PrintDetails: "/PrintDetails",
  ExportReport: "/ExportReport",
  GenerateReport: "/GenerateReport",
  TypesOfReports: "/TypesOfReports",
  TotalAccounts: "/TotalAccounts",
  CompleteCount: "/CompleteCount",
  DiscardCount: "/DiscardCount",
  ResetCounts: "/ResetCounts",
  IncludeExcludeCounts: "/IncludeExcludeCounts",
  DeleteCountedItem: "/DeleteCountedItem",
  CalcTotalItems: "/CalcTotalItems",
  GetAllItems: "/GetAllItems",
  GetCountedItems: "/GetCountedItems",
  GetUncountedItems: "/GetUncountedItems",
  GetMatchedItems: "/GetMatchedItems",
  GetUnmatchedItems: "/GetUnmatchedItems",
  GetExlculedItems: "/GetExlculedItems",
  GetLastCounts: "/GetLastCounts",
  PostCount: "/PostCount",
  GetDetails: "/GetDetails",
  TypesOfCountsMade: "/TypesOfCountsMade",
  LockAndFinalized: "/LockAndFinalized",
  DueCounts: "/DueCounts",
  UpcomingCounts: "/UpcomingCounts",
  CompletedCounts: "/CompletedCounts",
  CanceledCounts: "/CanceledCounts",
  CloseFiscalYear: "/CloseFiscalYear",
  SaveSnapshot: "/SaveSnapshot",
  TakeSnapshot: "/TakeSnapshot",
  LastFyClosingDate: "/LastFyClosingDate",
  ExportFiscalYears: "/ExportFiscalYears",
  ExportFiscalYearsPdf: "/ExportFiscalYearsPdf",
  ExpAccounts: "/ExpAccounts",
  ExportExpAccounts: "/ExportExpAccounts",
  ExportExpense: "/ExportExpense",
  ExportBankAccounts: "/ExportBankAccounts",
  ExportBankAccountsPdf: "/ExportBankAccountsPdf",
  GetReconcilableTxns: "/GetReconcilableTxns",
  ToggleCleared: "/ToggleCleared",
  BulkToggleCleared: "/BulkToggleCleared",
  Finalize: "/Finalize",
  Reopen: "/Reopen",
  ValidateInvoiceId: "/ValidateInvoiceId",
  GetSettings: "/GetSettings",
  ResetPassword: "/ResetPassword",
  IsUsernameExist: "/IsUsernameExist",
  ChangeStatus: "/ChangeStatus",
  UpdateStatus: "/UpdateStatus",
  ExportInquiries: "/ExportInquiries",
  RemoveBCST: "/RemoveBCST",
  GetDefaultMarkup: "/GetDefaultMarkup",
  UpdateBCST: "/UpdateBCST",
  DeleteSelectedProds: "/DeleteSelectedProds",
  UpdateProductsStatus: "/UpdateProductsStatus",
  UpdatePrices: "/UpdatePrices",
  ProductScanBySplr: "/ProductScanBySplr",
  ExportLabels: "/ExportLabels",
  GetLabels: "/GetLabels",
  GetAllByOrgPg: "/GetAllByOrgPg",
  GetAllByCoPg: "/GetAllByCoPg",
  GetByOutletPg: "/GetByOutletPg",
  ExportProducts: "/ExportProducts",
  StockReport: "/StockReport",
  AvgCostHistory: "/AvgCostHistory",
  ExportStockReport: "/ExportStockReport",
  ExportStockReportPdf: "/ExportStockReportPdf",
  ExportAvgCostHistory: "/ExportAvgCostHistory",
  ExportAvgCostHistoryPdf: "/ExportAvgCostHistoryPdf",
  LogReport: "/LogReport",
  ExportLogReport: "/ExportLogReport",
  ExportLogReportPdf: "/ExportLogReportPdf",
  GetAllByCo: "/GetAllByCo",
  GetAllLabelByCo: "/GetAllLabelByCo",
  Search: "/Search",
  GetAll: "/GetAll",
  GetById: "/GetById",
  Post: "/Post",
  Put: "/Put",
  Delete: "/Delete",
  GetAuthUser: "/GetAuthUser",
  Login: "/Login",
  Logout: "/Logout",
  Forgot: "/Forgot",
  ChgPass: "/ChgPass",
  GetAllByOutlet: "/GetAllByOutlet",
  GetAllByOrg: "/GetAllByOrg",
  GetAuthUserOutlets: "/GetAuthUserOutlets",
  GetAuthUserOrg: "/GetAuthUserOrg",
  GetDocNumberSettings: "/GetDocNumberSettings",
  SaveDocNumberSettings: "/SaveDocNumberSettings",
  CheckCstmrCode: "/CheckCstmrCode",
  GetAllMainCatByOrg: "/GetAllMainCatByOrg",
  GetAllCatBySubcat: "/GetAllCatBySubcat",
  FindProducts: "/FindProducts",
  MarkAsReceived: "/MarkAsReceived",
  VoidOrder: "/VoidOrder",
  GetInventory: "/GetInventory",
  GetDetailsById: "/GetDetailsById",
  ReceiveDelivery: "/ReceiveDelivery",
  MarkStatusAsSent: "/MarkStatusAsSent",
  ActiveAndInactive: "/ActiveAndInactive",
  GetStockByProd: "/GetStockByProd",
  GetOutletsWithRegisters: "/GetOutletsWithRegisters",
  GetCashierOpenReg: "/GetCashierOpenReg",
  CheckInvExist: "/CheckInvExist",
  GetActiveReg: "/GetActiveReg",
  GetLastClosingFloat: "/GetLastClosingFloat",
  ProductDetails: "/ProductDetails",
  GetAllByReg: "/GetAllByReg",
  RegSellWithPayType: "/RegSellWithPayType",
  PayTypeBreakdown: "/PayTypeBreakdown",
  CloseReg: "/CloseReg",
  Retrieve: "/Retrieve",
  GetByAuthUser: "/GetByAuthUser",
  SwitchUser: "/SwitchUser",
  CurrentMonthAndTodaySaleByUser: "/CurrentMonthAndTodaySaleByUser",
  ArchiveQuote: "/ArchiveQuote",
  GetAllByStatus: "/GetAllByStatus",
  GetCustomerAccounts: "/GetCustomerAccounts",
  GetByCustomer: "/GetByCustomer",
  GetAllByCustomer: "/GetAllByCustomer",
  GetAccountsByCustomer: "/GetAccountsByCustomer",
  CustomerDue: "/CustomerDue",
  PayBalance: "/PayBalance",
  VoidPayment: "/VoidPayment",
  FindCustomer: "/FindCustomer",
  FilterSales: "/FilterSales",
  ValidateImportProduts: "/ValidateImportProduts",
  UploadProducts: "/UploadProducts",
  ImportProducts: "/ImportProducts",
  UploadCustomers: "/UploadCustomers",
  ExportCustomers: "/ExportCustomers",
  UploadSuppliers: "/UploadSuppliers",
  ExportSuppliers: "/ExportSuppliers",
  ImportCoas: "/ImportCoas",
  AttachCustomer: "/AttachCustomer",
  Void: "/Void",
  FindProdsBySplr: "/FindProdsBySplr",
  HaveMultipleOutlet: "/HaveMultipleOutlet",
  GetBySellId: "/GetBySellId",
  GetReturnsBySellId: "/GetReturnsBySellId",
  FinancialTotals: "/FinancialTotals",
  TopSellingProducts: "/TopSellingProducts",
  TopSellingCustomers: "/TopSellingCustomers",
  OutletSalesReport: "/OutletSalesReport",
  InventoryReport: "/InventoryReport",
  SyncProducts: "/SyncProducts",
  SyncInventory: "/SyncInventory",
  GetAllBySupplier: "/GetAllBySupplier",
  GetAccountsBySupplier: "/GetAccountsBySupplier",
  GetPaymentVoucher: "/GetPaymentVoucher",
  GetExpenseVoucher: "/GetExpenseVoucher",
  GetPaymentReceipt: "/GetPaymentReceipt",
  SearchUnpaidInvoices: "/SearchUnpaidInvoices",
  GenerateOrderNum: "/GenerateOrderNum",
  GetByOrderNo: "/GetByOrderNo",
  GetAllCatLabelByOrg: "/GetAllCatLabelByOrg",
  GetAllLabelByOrg: "/GetAllLabelByOrg",
  GetTotalRecordByOrg: "/GetTotalRecordByOrg",
  GetProdsForPosBody: "/GetProdsForPosBody",
  GetServicesForPos: "/GetServicesForPos",
  FindEmployees: "/FindEmployees",
  FindBays: "/FindBays",
  FindProdFromPos: "/FindProdFromPos",
  ProdSelectForCart: "/ProdSelectForCart",
  ProductScan: "/ProductScan",
  ProfitAndLoss: "/ProfitAndLoss",
  ExportProfitAndLoss: "/ExportProfitAndLoss",
  SalesProfitSummary: "/SalesProfitSummary",
  CreditCustomer: "/CreditCustomer",
  ExportCreditCustomer: "/ExportCreditCustomer",
  ExportCreditCustomerPdf: "/ExportCreditCustomerPdf",
  ExportProductMovement: "/ExportProductMovement",
  ExportProductMovementPdf: "/ExportProductMovementPdf",
  ItemWiseSales: "/ItemWiseSales",
  ExportItemWiseSales: "/ExportItemWiseSales",
  ExportItemWiseSalesPdf: "/ExportItemWiseSalesPdf",
  ItemWiseSalesHistory: "/ItemWiseSalesHistory",
  ExportItemWiseSalesHistory: "/ExportItemWiseSalesHistory",
  CustomerWisePL: "/CustomerWisePL",
  ExportCustomerWisePL: "/ExportCustomerWisePL",
  ExportCustomerWisePLPdf: "/ExportCustomerWisePLPdf",
  ExpenseReport: "/ExpenseReport",
  ExportExpenseReport: "/ExportExpenseReport",
  ExportExpenseReportPdf: "/ExportExpenseReportPdf",
  ExpenseReportDetail: "/ExpenseReportDetail",
  ExportExpenseReportDetail: "/ExportExpenseReportDetail",
  ExportExpenseReportDetailPdf: "/ExportExpenseReportDetailPdf",
  ProfitByInvoice: "/ProfitByInvoice",
  ExportProfitByInvoice: "/ExportProfitByInvoice",
  ExportProfitByInvoicePdf: "/ExportProfitByInvoicePdf",
  InvoiceProfitDetail: "/InvoiceProfitDetail",
  FastMovingProds: "/FastMovingProds",
  SlowMovingProds: "/SlowMovingProds",
  TrialBalance: "/TrialBalance",
  ExportTrialBalance: "/ExportTrialBalance",
  BalanceSheet: "/BalanceSheet",
  ExportBalanceSheet: "/ExportBalanceSheet",
  ExportBalanceSheetPdf: "/ExportBalanceSheetPdf",
  TrialBalanceV2: "/TrialBalanceV2",
  ExportTrialBalanceV2: "/ExportTrialBalanceV2",
  ExportTrialBalanceV2Pdf: "/ExportTrialBalanceV2Pdf",
  GeneralLedger: "/GeneralLedger",
  ExportGeneralLedger: "/ExportGeneralLedger",
  ExportGeneralLedgerPdf: "/ExportGeneralLedgerPdf",
  GeneralLedgerAccount: "/GeneralLedgerAccount",
  JournalEntrySplit: "/JournalEntrySplit",
  ProfitAndLossV2: "/ProfitAndLossV2",
  ExportProfitAndLossV2: "/ExportProfitAndLossV2",
  ExportProfitAndLossV2Pdf: "/ExportProfitAndLossV2Pdf",
  SupplierAging: "/SupplierAging",
  SupplierAgingDetail: "/SupplierAgingDetail",
  ExportSupplierAging: "/ExportSupplierAging",
  ExportSupplierAgingPdf: "/ExportSupplierAgingPdf",
  CustomerAging: "/CustomerAging",
  CustomerAgingDetail: "/CustomerAgingDetail",
  ExportCustomerAging: "/ExportCustomerAging",
  ExportCustomerAgingPdf: "/ExportCustomerAgingPdf",
  GetProdDetailsForUpdatePrice: "/GetProdDetailsForUpdatePrice",
  PostDirectReturn: "/PostDirectReturn",
  GetCustomerPurchaseHistory: "/GetCustomerPurchaseHistory",
  ValidateProductSold: "/ValidateProductSold",
  EditSell: "/Edit",
  Reconcile: "/Reconcile",
  ReconcileByOutlet: "/ReconcileByOutlet",
  ReconcileByCompany: "/ReconcileByCompany",
  GetByProduct: "/GetByProduct",
  SyncStockPayments: "/SyncStockPayments",
  GetPlanByCompany: "/GetPlanByCompany",
  SavePlan: "/SavePlan",
  DeleteTier: "/DeleteTier",
  DeleteItemRate: "/DeleteItemRate",
  CalculateCommissions: "/CalculateCommissions",
  GetCommissionDetails: "/GetCommissionDetails",
  PayCommission: "/PayCommission",
  VoidCommissionPayment: "/VoidCommissionPayment",
  FinalizeTargetCommissions: "/FinalizeTargetCommissions",
  GetCommissionPaymentHistory: "/GetPaymentHistory",
  GetEmployeePayable: "/GetEmployeePayable",
  GetEmployeeProfileSummary: "/GetEmployeeProfileSummary",
  GetEmployeeCommissionLedger: "/GetEmployeeCommissionLedger",
  ExportEmployeeCommissionLedger: "/ExportEmployeeCommissionLedger",
  ExportCommissionReport: "/ExportCommissionReport",
  ExportCommissionReportPdf: "/ExportCommissionReportPdf",
  GetCompanyPayables: "/GetCompanyPayables",
  SearchLabels: "/SearchLabels",
  // ---- Payment Report v2 ----
  GetPaymentsPg: "/GetPaymentsPg",
  GetPaymentDetail: "/GetPaymentDetail",
  // ---- Sales Summary ----
  GetSalesPg: "/GetSalesPg",
  GetSaleDetail: "/GetSaleDetail",
  // ---- Business Activity Dashboard ----
  GetSnapshot: "/GetSnapshot",
  // ---- Cash Sales Invoice list dashboard tiles ----
  GetSummary: "/GetSummary",
  // ---- Promotion engine ----
  ExportExcel: "/ExportExcel",
  ExportPdf: "/ExportPdf",
  SetStatus: "/SetStatus",
  BulkGenerate: "/BulkGenerate",
  Validate: "/Validate",
  Redemptions: "/Redemptions",
  AuditLog: "/AuditLog",
  Dashboard: "/Dashboard",
  PerCoupon: "/PerCoupon",
  PerCustomer: "/PerCustomer",
  Pending: "/Pending",
  Approve: "/Approve",
  Reject: "/Reject",
};

export const API = (endpoint) => {
  const url = BaseUrl + endpoint + "/";

  const get = async (onComplete) => {
    try {
      const { data } = await axios.get(url, { withCredentials: true });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const getById = async (id, onComplete) => {
    try {
      const { data } = await axios.get(url + id, { withCredentials: true });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const post = async (data, onComplete) => {
    try {
      const res = await axios.post(url, data, { withCredentials: true });
      if (onComplete) return onComplete(res.data);
      return res.data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const put = async (data, onComplete) => {
    try {
      const res = await axios.put(url, data, { withCredentials: true });
      if (onComplete) return onComplete(res.data);
      return res.data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const Delete = async (id, onComplete) => {
    try {
      const { data } = await axios.delete(url + id, { withCredentials: true });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const patchById = async (id, onComplete) => {
    try {
      const { data } = await axios.patch(url + id, null, {
        withCredentials: true,
      });
      if (onComplete) return onComplete(data);
      return data;
    } catch (err) {
      console.error("Error: ", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const postFile = async (data, onComplete) => {
    try {
      const res = await axios.post(url, data, {
        withCredentials: true,
        responseType: "blob",
      });
      if (onComplete) return onComplete(res);
      return res;
    } catch (err) {
      console.error("File download error:", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  const getFileById = async (id, onComplete) => {
    try {
      const res = await axios.get(url + id, {
        withCredentials: true,
        responseType: "blob",
      });
      if (onComplete) return onComplete(res);
      return res;
    } catch (err) {
      console.error("File download error:", err);
      if (onComplete) return onComplete(undefined, err);
      throw err;
    }
  };

  return {
    get,
    getById,
    post,
    put,
    Delete,
    patchById,
    postFile,
    getFileById,
  };
};
